import { CART_STATUS as o } from "@smart/types";
import { p } from "./index-xuotMAFm.mjs";
function $(e) {
  const r = [];
  for (let n = 0; n < (e == null ? void 0 : e.length); n++) {
    const t = e == null ? void 0 : e[n];
    t && r.push({ ...t });
  }
  return r;
}
const f = ["en-GB"];
function _(e, r, n) {
  if (e === void 0)
    return "";
  const s = e.toFixed(2).split("."), c = s[0], i = s[1];
  if (!c || !i)
    return e.toString();
  const a = parseInt(c).toLocaleString(r), l = f.includes(r);
  return i === "00" ? l ? `${n}${a}` : `${a} ${n}` : l ? `${n}${a},${i}` : `${a},${i} ${n}`;
}
const R = (e) => ({
  isCreated: e === o.CREATED,
  isIdealPaymentPending: e === o.IDEAL_PAYMENT_PENDING,
  isProcessing: e === o.PROCESSING,
  isInProgress: e === o.IN_PROGRESS,
  isOnHold: e === o.ON_HOLD,
  isPendingEsignature: e === o.PENDING_ESIGNATURE,
  isPendingVerification: e === o.PENDING_VERIFICATION,
  isFrozen: [
    o.IDEAL_PAYMENT_PENDING,
    o.ON_HOLD,
    o.PENDING_ESIGNATURE,
    o.PENDING_VERIFICATION
  ].includes(e)
}), D = (e, r = { required: !0 }) => {
  const n = p.env[e];
  if (r != null && r.required && !n)
    throw new Error(
      `Environment variable ${e} is required but was not provided.`
    );
  if (r != null && r.json && n)
    try {
      return JSON.parse(n);
    } catch {
      throw new Error(`Error parsing environment variable ${e} as JSON.`);
    }
  return n || (r == null ? void 0 : r.default);
}, O = (e, r) => e == null ? void 0 : e[r], m = (e) => e ? e.reduce((r, n) => {
  let t = -1;
  const s = r.find((c, i) => (t = i, c.priority === n.priority));
  return s && t > -1 ? (r[t] = {
    ...s,
    description: `${s.description}<br/>${n.description}`
  }, r) : (r.push(n), r);
}, []) : [], A = (e, r = 3) => m(e).slice(0, r), u = "{{product}}", d = "{{model}}", g = "{{featureApp}}", P = `smart/smart-dam/digital/products/cars/${d}/specific/${u}/${g}/`, L = (e, r, n) => P.replace(u, r).replace(d, n).replace(g, e);
function b(e, r, n) {
  const t = e.find((s) => s[r] === n);
  return t || null;
}
const H = (e) => {
  switch (e == null ? void 0 : e.substring(0, 3)) {
    case "HX1":
    case "HXY":
      return "smart #1";
    case "HC1":
      return "smart #3";
    case "HY1":
      return "smart #5";
    default:
      return;
  }
}, v = (e) => {
  const r = e.toUpperCase();
  if (r.includes("MRS") || r.includes("MISS") || r.includes("MS"))
    return 1;
  if (r.includes("MR"))
    return 0;
};
function x(e, r) {
  return e[r] ?? e.DEFAULT;
}
function G({
  value: e,
  record: r
}) {
  return e ? Object.values(r).some(
    (n) => n.toString().toUpperCase() === e.toString().toUpperCase()
  ) : !1;
}
function F(e) {
  return e === "" || e === void 0 || e === null;
}
const M = (e) => {
  const [r] = e.split("-");
  return r;
}, U = (e) => {
  const [, r] = e.split("-");
  return r;
};
function q(e) {
  let r = !1;
  return {
    promise: new Promise((s, c) => {
      e.then(
        (i) => !r && s(i),
        (i) => !r && c(i)
      );
    }),
    cancel: () => {
      r = !0;
    }
  };
}
function W(e, r) {
  return r.reduce((t, s) => (t[s] = e[s], t), {});
}
function j(e) {
  return e.reduce(
    (r, { condition: n, value: t }) => n ? { ...r, ...t } : r,
    {}
  );
}
const E = new RegExp(
  /^(?<vehicleTypeCode>\w{3})(?<engineCode>\w{2})(?<salesVersionCode>\w{2})(?<yearEditionCode>\w{1})(?<transmissionCode>\w{1})(?<steeringWheelCode>\w{1})(?<marketCode>\w{2})(?<sixDigitsCode>\d{6})$/g
);
function B(e) {
  if (e.length !== 18)
    return;
  const r = E.exec(e);
  if (r != null && r.groups)
    return r.groups;
}
const C = {
  legalWLTP: ["consumption_wltp_combined", "powerconsumptioncombined"],
  legalEmissions: "co2emissioncombined",
  legalRange: "range_wltp_combined",
  legalRangeCity: "range_wltp_city"
}, N = {
  legalNEDC: "---"
}, I = (e) => C[e], y = (e, r) => {
  const n = e.includes(r);
  if (!n) {
    const t = I(r);
    if (!t)
      return !1;
    const s = Array.isArray(t) && t.some((i) => e.includes(i)), c = typeof t == "string" && e.includes(t);
    return s || c;
  }
  return n;
}, S = (e, r) => {
  const n = r == null ? void 0 : r.find(
    (t) => y(t.code, e)
  );
  return n != null && n.value ? n == null ? void 0 : n.value : N[e] || `{{${e}}}`;
}, V = (e, r) => e.replace(
  /{{\w+}}/g,
  function(t) {
    const s = t.substring(
      2,
      t.length - 2
    );
    return S(s, r);
  }
), k = (e) => {
  try {
    return JSON.parse(e);
  } catch {
    return;
  }
};
export {
  D as a,
  O as b,
  $ as c,
  A as d,
  L as e,
  _ as f,
  R as g,
  b as h,
  H as i,
  v as j,
  x as k,
  G as l,
  F as m,
  M as n,
  U as o,
  q as p,
  W as q,
  j as r,
  B as s,
  S as t,
  V as u,
  k as v
};
//# sourceMappingURL=safe-json-parse-CzuLFWuO.mjs.map
